import { useContext } from "react";

import { NudgeCtx } from "./nudge.provider";
import type { NudgeContext, Nullable } from "./nudge.types";

export const useNudge = () => {
  const context = useContext(NudgeCtx);

  if (!context) {
    throw new Error("useNudge must be used within a NudgeProvider");
  }

  return context;
};

/**
 * Non-throwing variant for widely-shared components (e.g. EmptyState) that
 * support an *optional* dismiss behaviour and must not crash if ever rendered
 * outside a NudgeProvider. Returns null when no provider is present.
 */
export const useNudgeOptional = (): Nullable<NudgeContext> =>
  useContext(NudgeCtx);
